import { render } from "./Impress.vue?vue&type=template&id=e56ca438"
import script from "./Impress.vue?vue&type=script&lang=ts"
export * from "./Impress.vue?vue&type=script&lang=ts"
script.render = render

export default script